// Hide Emergent badge dynamically
export const hideBadge = () => {
  const hideElements = () => {
    // Find and hide all elements that might be the badge
    const selectors = [
      'a[href*="emergent.sh"]',
      'div[style*="z-index: 9999"]',
      'div[style*="z-index: 999999"]',
      '[data-emergent]',
      'iframe[src*="emergent"]'
    ];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        // Check if it's not part of our app (exclude header links)
        if (!el.closest('header') && !el.closest('footer')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
        }
      });
    });

    // Look for text "Made with Emergent"
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const nodesToHide = [];
    while (walker.nextNode()) {
      if (walker.currentNode.textContent.includes('Made with Emergent')) {
        nodesToHide.push(walker.currentNode.parentElement);
      }
    }

    nodesToHide.forEach(node => {
      if (node && !node.closest('header') && !node.closest('footer')) {
        let current = node;
        while (current && current !== document.body) {
          current.style.display = 'none';
          current = current.parentElement;
          // Only go up a few levels
          if (current?.style?.position === 'fixed') break;
        }
      }
    });
  };

  // Run immediately
  hideElements();

  // Run after DOM changes
  const observer = new MutationObserver(hideElements);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Run periodically as backup
  setInterval(hideElements, 1000);

  return () => observer.disconnect();
};
